<template>
	<v-img
		v-if="group.iconUrl && !loadError"
		:src="group.iconUrl"
		max-height="24"
		max-width="24"
		contain
		@error="error"
	>
		<template #placeholder>
			<v-skeleton-loader
				type="avatar"
				loading
			/>
		</template>
	</v-img>
	<v-icon v-else>fa-building</v-icon>
</template>

<script>
export default {
	props: {
		group: {
			type: Object,
			required: true,
		},

		highlight: {
			type: Boolean,
			default: undefined,
		},
	},

	data: () => ({
		loadError: false,
	}),

	methods: {
		error(e) {
			this.loadError = true;

			// Notify bugsnag that we failed to load an image
			this.$bugsnagClient.notify(e);
		},
	},
};
</script>
